module.exports = __webpack_public_path__ + "img/success.9567cd5b.svg";